module.exports = __webpack_public_path__ + "static/map_usa_WE-59eac00d3e0fd25dab07205803f993f2.png";